import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PendingSubscriptions } from '../../../../data';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import { useTemplate } from '../../../features/template/TemplateProvider';
import PageTitle from '../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../utils/URL';
import { handleGetPendingSubscriptionsOpe } from '../SubscriptionsOperation';
import PendingSubsPageHeader from './Components/PendingSubsPageHeader';
import PendingSubsPageHeaderMobile from './Components/PendingSubsPageHeaderMobile';
import PendingSubsPageTableMobile from './Components/PendingSubsPageTableMobile';
import PendingSubscriptionTable from './Components/PendingSubscriptionTable';

function SubscriptionPendingPage() {
    // set page title
    PageTitle(`Subscriptions`);

    const [pendingSubsData, setPendingSubsData] = useState({
        subscriptions: PendingSubscriptions,
        pagination: {}
    });
    const [reloadKey, setReloadKey] = useState(0);
    const { setMessage } = useTemplate();

    const navigate = useNavigate();

    // Search Params
    const [searchParams] = useSearchParams();
    const p = useMemo(
        () => ({
            'order-by': searchParams.get('order-by'),
            sort: searchParams.get('sort') || 'desc'
        }),
        [searchParams]
    );

    // -- Load pending subscriptions initially
    useEffect(() => {
        setPendingSubsData({ subscriptions: PendingSubscriptions, pagination: {} });
        handleGetPendingSubscriptionsOpe()
            .then(({ data }) => {
                setPendingSubsData({ subscriptions: data?.subscriptions, pagination: {} });
            })
            .catch((err) => {
                setPendingSubsData({ subscriptions: [], pagination: {} });
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, reloadKey]);

    const handleSortingData = (column) => {
        navigate(
            mkRelativeUrl('/subscriptions/pending', {
                ...p,
                'order-by': column,
                sort: p.sort === 'desc' ? 'asc' : 'desc'
            })
        );
    };

    const handleReload = () => {
        setReloadKey((d) => d + 1);
    };

    return (
        <div className="subscriptions_pending_page inner_page_cont ">
            <LayoutProvider>
                <PendingSubsPageHeader handleReload={handleReload} layout="default" />
                <PendingSubsPageHeaderMobile
                    handleReload={handleReload}
                    layout={['md', 'sm', 'xs', 'xxs']}
                />
            </LayoutProvider>
            <LayoutProvider>
                <PendingSubscriptionTable
                    layout="default"
                    data={pendingSubsData}
                    sortBy={p.sort}
                    sortedColumn={p['order-by']}
                    sortedHandler={handleSortingData}
                />
                <PendingSubsPageTableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={pendingSubsData}
                />
            </LayoutProvider>
        </div>
    );
}
export default SubscriptionPendingPage;
